<h2>Deliverables for Product : {{ productId() }}</h2>
<hr />
<button
    class="button-add-row"
    mat-flat-button
    (click)="addDeliverableRow()"
    color="primary"
>
    Add new Deliverable
</button>
<table mat-table [dataSource]="productDeliverables">
    <form [formGroup]="mappingGroup">
        @for (col of columnsSchema; track col) {
            <ng-container [matColumnDef]="col.key">
                <th mat-header-cell *matHeaderCellDef>
                    {{ col.label }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let element"
                    class="deliverable-table-edit-td"
                >
                    @if (!element.isEdit) {
                        <div>
                            @switch (col.type) {
                                @case ("isEdit") {
                                    <div class="btn-edit">
                                        <!--<button mat-flat-button (click)="element.isEdit = !element.isEdit" color="primary">Edit</button>-->
                                    </div>
                                }
                                @default {
                                    <span>
                                        {{ element[col.key] }}
                                    </span>
                                }
                            }
                        </div>
                    }
                    @if (element.isEdit) {
                        <div>
                            @switch (col.type) {
                                @case ("isEdit") {
                                    <div class="btn-edit">
                                        @if (element.isAdd) {
                                            <button
                                                mat-mini-fab
                                                (click)="
                                                    addDeliverable(element)
                                                "
                                                color="accent"
                                            >
                                                <mat-icon>check</mat-icon>
                                            </button>
                                        }
                                        @if (!element.isAdd) {
                                            <button
                                                mat-mini-fab
                                                (click)="
                                                    editDeliverable(element)
                                                "
                                                color="accent"
                                            >
                                                <mat-icon>check</mat-icon>
                                            </button>
                                        }
                                        <button
                                            mat-mini-fab
                                            (click)="
                                                cancelAddedDeliverableRow(
                                                    element
                                                )
                                            "
                                            color="primary"
                                        >
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                }
                                @case ("list") {
                                    <mat-form-field>
                                        <mat-select
                                            [formControlName]="col.key"
                                            [(ngModel)]="element[col.key]"
                                        >
                                            @for (
                                                item of col.list;
                                                track item
                                            ) {
                                                <mat-option
                                                    [value]="item.enum"
                                                    >{{ item.enum }}</mat-option
                                                >
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                }
                                @default {
                                    <mat-form-field>
                                        <input
                                            [type]="col.type"
                                            [formControlName]="col.key"
                                            matInput
                                            [(ngModel)]="element[col.key]"
                                        />
                                    </mat-form-field>
                                }
                            }
                        </div>
                    }
                </td>
            </ng-container>
        }
    </form>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
